export default __webpack_public_path__ + "static/Slide1-921534f6383002102c8f144218c2f278.png";